import { Teksten } from "../../../content";
import { Melding } from "../../../models";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { login } from "../../../store/reducers/auth";
import { selectAuth, selectMelding } from "../../../store/selectors";
import { ContainerAtom } from "../../atoms";
import { ButtonMolecule, JumbotronMolecule } from "../../molecules";
import { HulpContact } from "../hulp-contact";
import { PortaalInfoOrganism } from "../portaal-info";

export function LoginFormOrganism() {
  const dispatch = useAppDispatch();
  const { fetching } = useAppSelector(selectAuth);
  const { meldingen } = useAppSelector(selectMelding);

  const onAuthenticate = () => {
    dispatch(login());
  };

  return (
    <div>
      <JumbotronMolecule
        center
        header={Teksten.login.nietAuth.header}
        link={
          <ButtonMolecule
            id={Teksten.login.nietAuth.id}
            title={Teksten.login.nietAuth.title}
            loading={fetching}
            text={Teksten.login.nietAuth.text}
            type="primary"
            onClick={onAuthenticate}
          />
        }
        intro={Teksten.login.nietAuth.intro}
      />
      {meldingen.map((melding: Melding) => {
        return (
          <JumbotronMolecule
            key={melding.id}
            header={Teksten.login.storing.header}
            intro={melding.omschrijving}
            type="warning"
            center
          />
        );
      })}
      <ContainerAtom type="row">
        <PortaalInfoOrganism />
        <HulpContact />
      </ContainerAtom>
    </div>
  );
}
